import axios from 'axios';
import { clearAuthCookiesDocument, clearBrowserSession, markSessionExpiredNotice } from '../authSession';

export function getApiBaseUrl() {
    const fromEnv =
        process.env.REACT_APP_API_URL ||
        process.env.REACT_APP_API_BASE_URL;
    if (fromEnv) {
        return fromEnv;
    }
    if (typeof window !== 'undefined') {
        const host = (window.location.hostname || '').toLowerCase();
        // Same-origin API on deployed hosts (demo.litvik.in, Railway, etc.)
        if (
            host &&
            host !== 'localhost' &&
            host !== '127.0.0.1' &&
            !host.endsWith('.local')
        ) {
            return `${window.location.origin}/api`;
        }
    }
    return 'http://localhost:8000/api';
}

export function clearAuthSession() {
    clearAuthCookiesDocument();
    clearBrowserSession();
}

export function handleUnauthorized() {
    const path = (window.location.pathname || '/').replace(/\/+$/, '') || '/';
    const alreadyOnLogin = path === '/' || path === '';
    markSessionExpiredNotice();
    clearAuthSession();
    if (!alreadyOnLogin) {
        window.location.assign('/');
    }
}

export function getApiClient(cookies) {

    const axiosClient = axios.create({
        headers: {
            'Authorization': `Token ${cookies?.myToken || ''}`,
            'Content-Type': "application/json",
        }
    });

    axiosClient.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response.status === 401) {
                handleUnauthorized();
            }
            return Promise.reject(error);
        }
    );
    
    return axiosClient;
}